export default __webpack_public_path__ + "static/media/Aiden.b134d955.jpg";